import React from "react";
import PropTypes from 'prop-types';

import JobsList from "./JobsList";
import Testimonial from "./Testimonial";
import style from "./TeamInfo.css";
import TeamIcon from "../TeamIcons/TeamIcon";
import Button from "../Button";

const TeamInfo = ({ team, jobs }) => {
  const teamJobs = jobs.filter((job) =>
    team.workableDepartmentCodes.includes(job.code)
  );
  let testimonial;

  if (!teamJobs.length) {
    return null;
  }

  if (team.name === "Technology") {
    testimonial = (
      <div className={style.techCTA}>
        <h4 className={style.techCTATitle}>Technology at Treatwell</h4>
        <Button to="/tech" label="Learn more" />
      </div>
    );
  } else if (team.members.length === 0) {
    testimonial = null;
  } else {
    testimonial = (
      <Testimonial
        team={team} />
    );
  }

  return (
    <div className={style.teamInfo}>
      <div className={style.info}>
        <div className={style.header}>
          <TeamIcon team={team} />
          <h3 className={style.title}>{team.name}</h3>
        </div>
        <p className={style.body}>{team.body}</p>
      </div>
      <div className={style.infoTestimonial}>
        {testimonial}
      </div>
      <div className={style.jobsList}>
        <JobsList jobs={teamJobs} />
      </div>
    </div>
  );
};

TeamInfo.propTypes = {
  team: PropTypes.object.isRequired,
  jobs: PropTypes.array.isRequired
};

export default TeamInfo;



// WEBPACK FOOTER //
// ./component/TeamList/TeamInfo.js